<script>
import { ElSelectV2 } from 'element-plus';
import ModalSimulatorQuestionComponent from '../../features/modals/ModalSimulatorQuestionComponent';

export default {
  name: 'ModalSimulatorQuestionView',
  components: {
    ElSelectV2,
  },
  extends: ModalSimulatorQuestionComponent,
  computed: {
    isUpdate() {
      return this.formData?.state === 'update' || Boolean(this.formData?.id);
    },
    modalTitle() {
      return this.isUpdate ? 'Actualizar Pregunta de Simulador' : 'Registrar Pregunta de Simulador';
    },
    modalSubtitle() {
      return this.isUpdate
        ? 'Modifica los parámetros de configuración, redacción y alternativas de respuesta'
        : 'Configura los parámetros iniciales, enunciado y alternativas de respuesta para el simulador';
    },
    submitIcon() {
      if (this.formData?.state === 'create' && this.active === 0) {
        return 'fas fa-arrow-right';
      }
      return 'fas fa-save';
    },
    careerOptions() {
      if (!Array.isArray(this.careers)) return [];
      return this.careers
        .filter((item) => item && item.id)
        .map((item) => ({
          value: item,
          label: item.name || item.code || 'Sin nombre',
        }));
    },
  },
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    class="subscription-account-modal simulator-question-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <!-- Cabecera estandarizada con ícono y subtítulo -->
    <template #header>
      <div class="student_modal_header">
        <div class="student_modal_header_icon">
          <i class="fas fa-laptop-code" />
        </div>
        <div class="student_modal_header_info">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h3 class="student_modal_title">
              {{ modalTitle }}
            </h3>
            <span
              v-if="formData.state === 'create'"
              class="question_badge_pill pill-counter"
            >
              <i class="fas fa-tasks mr-1" /> Pregunta {{ totalQuestions }} de {{ formData.quantityQuestions || 1 }}
            </span>
            <span
              v-else-if="formData.code"
              class="question_badge_pill pill-primary"
            >
              <i class="fas fa-barcode mr-1" /> {{ formData.code }}
            </span>
          </div>
          <p class="student_modal_subtitle">
            {{ modalSubtitle }}
          </p>
        </div>
      </div>
    </template>

    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <!-- Modo Creación con Pasos -->
      <div v-if="formData.state === 'create'">
        <div class="simulator_question_steps_wrap">
          <el-steps
            :active="active"
            align-center
            finish-status="success"
          >
            <el-step
              title="Parámetros de Configuración"
              description="Clasificación y alcance"
            />
            <el-step
              title="Enunciado y Alternativas"
              description="Redacción de la pregunta y respuestas"
            />
          </el-steps>
        </div>

        <div v-if="active === 0">
          <!-- Tarjeta 1: Parámetros Generales -->
          <div class="student_form_section">
            <div class="student_section_header">
              <h4 class="student_section_title">
                <i class="fas fa-sliders-h" /> Parámetros Generales
              </h4>
            </div>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
              >
                <el-form-item
                  label="Número de Preguntas"
                  prop="quantityQuestions"
                >
                  <el-input-number
                    v-model="formData.quantityQuestions"
                    :min="1"
                    :max="1000"
                    size="small"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
              >
                <el-form-item
                  label="Tipo de Simulador"
                  prop="type"
                >
                  <el-select
                    v-model="formData.type"
                    clearable
                    filterable
                    remote
                    :remote-method="onFindSimulatorExamType"
                    placeholder="Seleccionar tipo"
                    value-key="id"
                    size="small"
                    style="width: 100%;"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in simulatorTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
              >
                <el-form-item
                  label="Nivel de Dificultad"
                  prop="difficultyLevel"
                >
                  <el-select
                    v-model="formData.difficultyLevel"
                    clearable
                    placeholder="Seleccionar dificultad"
                    value-key="id"
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in difficultyLevels"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
              >
                <el-form-item
                  label="Categoría"
                  prop="simulatorQuestionCategory"
                >
                  <el-select
                    v-model="formData.simulatorQuestionCategory"
                    clearable
                    filterable
                    remote
                    :remote-method="onFindSimulatorQuestionCategories"
                    placeholder="Seleccionar categoría"
                    value-key="id"
                    size="small"
                    style="width: 100%;"
                    @change="onSelectSimulatorQuestionCategory"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in simulatorQuestionCategories"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- Tarjeta 2: Clasificación Académica -->
          <div class="student_form_section">
            <div class="student_section_header">
              <h4 class="student_section_title">
                <i class="fas fa-university" /> Clasificación Académica
              </h4>
            </div>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col
                :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
              >
                <el-form-item
                  label="Universidad"
                  prop="university"
                >
                  <el-select
                    v-model="formData.university"
                    clearable
                    filterable
                    remote
                    :remote-method="onFindUniversity"
                    placeholder="Buscar y seleccionar universidad"
                    value-key="id"
                    size="small"
                    style="width: 100%;"
                    @change="onSelectUniversity"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in universities"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
                align="center"
              >
                <el-form-item
                  label="¿Es Especialidad?"
                  prop="isSpecialty"
                >
                  <el-switch
                    v-model="formData.isSpecialty"
                    active-color="#10B981"
                    inactive-color="#CBD5E1"
                    active-text="SI"
                    inactive-text="NO"
                    @change="onChangeIsSpecialty"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="6"
                :lg="6"
                align="center"
              >
                <el-form-item
                  label="¿Todas las Carreras Disponibles?"
                  prop="allSpecialities"
                >
                  <el-switch
                    v-model="formData.allSpecialities"
                    active-color="#10B981"
                    inactive-color="#CBD5E1"
                    active-text="SI"
                    inactive-text="NO"
                    :disabled="!formData.isSpecialty"
                    @change="onChangeAllSpecialities"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Carrera(s)"
                  prop="specialties"
                >
                  <el-select-v2
                    v-model="formData.specialties"
                    :options="careerOptions"
                    placeholder="Seleccionar carreras asociadas"
                    value-key="id"
                    multiple
                    clearable
                    filterable
                    collapse-tags
                    collapse-tags-tooltip
                    :max-collapse-tags="3"
                    :disabled="!formData.isSpecialty"
                    style="width: 100%;"
                    @change="onChangeSpecialties"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div v-if="active === 1">
          <!-- Tarjeta 1: Contenido de la Pregunta -->
          <div class="student_form_section">
            <div class="student_section_header">
              <h4 class="student_section_title">
                <i class="fas fa-edit" /> Contenido de la Pregunta
              </h4>
            </div>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Pregunta / Título"
                  prop="name"
                >
                  <el-input
                    v-model="formData.name"
                    placeholder="Escribe el enunciado corto o título de la pregunta..."
                    maxlength="200"
                    show-word-limit
                    clearable
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Descripción Detallada / Instrucciones"
                  prop="tags"
                >
                  <el-input
                    v-model="formData.description"
                    type="textarea"
                    class="description-editor"
                    :rows="4"
                    maxlength="255"
                    placeholder="Escribe la descripción o instrucciones de la pregunta..."
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- Tarjeta 2: Alternativas de Respuesta -->
          <div class="student_form_section simulator_answers_card">
            <div class="student_section_header">
              <h4 class="student_section_title">
                <i class="fas fa-list-check" /> Alternativas de Respuesta
              </h4>
              <el-button
                type="primary"
                size="small"
                class="btn_add_answer"
                @click="onAddAnswer"
              >
                <i class="fas fa-plus-circle mr-1" /> Agregar Respuesta
              </el-button>
            </div>

            <el-table
              v-loading="isAnswerLoading"
              :data="formData.getAnswers()"
              row-key="id"
              empty-text="No se encontraron alternativas de respuesta registradas."
              class="simulator_answers_table"
            >
              <el-table-column
                label="RESPUESTA"
                min-width="300"
              >
                <template #default="scope">
                  <div>
                    <el-form-item
                      :prop="'simulatorAnswers.' + scope.$index + '.description'"
                      :rules="[{ required: true, message: 'Respuesta requerida.'}, { validator: isAnswerValid}]"
                    >
                      <el-input
                        v-model="scope.row.description"
                        size="small"
                        placeholder="Texto de la alternativa..."
                        :class="'answer_editor_' + scope.$index"
                      />
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="CORRECTA"
                width="130"
                align="center"
              >
                <template #default="scope">
                  <div>
                    <el-switch
                      v-model="scope.row.success"
                      active-color="#10B981"
                      inactive-color="#CBD5E1"
                      active-text="SI"
                      inactive-text="NO"
                      size="small"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="OPCIONES"
                width="90"
                align="center"
              >
                <template #default="scope">
                  <el-button
                    type="danger"
                    size="small"
                    class="btn_delete_answer"
                    title="Eliminar respuesta"
                    @click="onDeleteAnswer(scope.$index)"
                  >
                    <i class="fas fa-trash-alt" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- Modo Edición / Actualización -->
      <div v-if="formData.state === 'update'">
        <!-- Tarjeta 1: Parámetros y Clasificación -->
        <div class="student_form_section">
          <div class="student_section_header">
            <h4 class="student_section_title">
              <i class="fas fa-sliders-h" /> Parámetros y Clasificación
            </h4>
          </div>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="12"
              :md="4"
              :lg="4"
            >
              <el-form-item
                label="Código"
                prop="code"
              >
                <el-input
                  v-model="formData.code"
                  size="small"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="5"
              :lg="5"
            >
              <el-form-item
                label="Tipo de Simulador"
                prop="type"
              >
                <el-select
                  v-model="formData.type"
                  clearable
                  filterable
                  remote
                  :remote-method="onFindSimulatorExamType"
                  placeholder="Seleccionar tipo"
                  value-key="id"
                  size="small"
                  style="width: 100%;"
                  @focus="onFocus"
                >
                  <el-option
                    v-for="item in simulatorTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="5"
              :lg="5"
            >
              <el-form-item
                label="Nivel de Dificultad"
                prop="difficultyLevel"
              >
                <el-select
                  v-model="formData.difficultyLevel"
                  clearable
                  placeholder="Seleccionar dificultad"
                  value-key="id"
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in difficultyLevels"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="10"
              :lg="10"
            >
              <el-form-item
                label="Categoría"
                prop="simulatorQuestionCategory"
              >
                <el-select
                  v-model="formData.simulatorQuestionCategory"
                  clearable
                  filterable
                  remote
                  :remote-method="onFindSimulatorQuestionCategories"
                  placeholder="Seleccionar categoría"
                  value-key="id"
                  size="small"
                  style="width: 100%;"
                  @change="onSelectSimulatorQuestionCategory"
                  @focus="onFocus"
                >
                  <el-option
                    v-for="item in simulatorQuestionCategories"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
            >
              <el-form-item
                label="Universidad"
                prop="university"
              >
                <el-select
                  v-model="formData.university"
                  clearable
                  filterable
                  remote
                  :remote-method="onFindUniversity"
                  placeholder="Buscar y seleccionar universidad"
                  value-key="id"
                  size="small"
                  style="width: 100%;"
                  @change="onSelectUniversity"
                  @focus="onFocus"
                >
                  <el-option
                    v-for="item in universities"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              align="center"
            >
              <el-form-item
                label="¿Es Especialidad?"
                prop="isSpecialty"
              >
                <el-switch
                  v-model="formData.isSpecialty"
                  active-color="#10B981"
                  inactive-color="#CBD5E1"
                  active-text="SI"
                  inactive-text="NO"
                  @change="onChangeIsSpecialty"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              align="center"
            >
              <el-form-item
                label="¿Todas las Carreras Disponibles?"
                prop="allSpecialities"
              >
                <el-switch
                  v-model="formData.allSpecialities"
                  active-color="#10B981"
                  inactive-color="#CBD5E1"
                  active-text="SI"
                  inactive-text="NO"
                  :disabled="!formData.isSpecialty"
                  @change="onChangeAllSpecialities"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Carrera(s)"
                prop="specialties"
              >
                <el-select-v2
                    v-model="formData.specialties"
                    :options="careerOptions"
                    placeholder="Seleccionar carreras asociadas"
                    value-key="id"
                    multiple
                    clearable
                    filterable
                    collapse-tags
                    collapse-tags-tooltip
                    :max-collapse-tags="3"
                    :disabled="!formData.isSpecialty"
                    style="width: 100%;"
                    @change="onChangeSpecialties"
                  />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- Tarjeta 2: Contenido de la Pregunta -->
        <div class="student_form_section">
          <div class="student_section_header">
            <h4 class="student_section_title">
              <i class="fas fa-edit" /> Contenido de la Pregunta
            </h4>
          </div>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Pregunta / Título"
                prop="name"
              >
                <el-input
                  v-model="formData.name"
                  placeholder="Escribe el enunciado corto o título de la pregunta..."
                  maxlength="200"
                  show-word-limit
                  clearable
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Descripción Detallada / Instrucciones"
                prop="tags"
              >
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  class="description-editor"
                  :rows="4"
                  maxlength="255"
                  placeholder="Escribe la descripción o instrucciones de la pregunta..."
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- Tarjeta 3: Alternativas de Respuesta -->
        <div class="student_form_section simulator_answers_card">
          <div class="student_section_header">
            <h4 class="student_section_title">
              <i class="fas fa-list-check" /> Alternativas de Respuesta
            </h4>
            <el-button
              type="primary"
              size="small"
              class="btn_add_answer"
              @click="onAddAnswer"
            >
              <i class="fas fa-plus-circle mr-1" /> Agregar Respuesta
            </el-button>
          </div>

          <el-table
            v-loading="isAnswerLoading"
            :data="formData.getAnswers()"
            row-key="id"
            empty-text="No se encontraron alternativas de respuesta registradas."
            class="simulator_answers_table"
          >
            <el-table-column
              label="RESPUESTA"
              min-width="300"
            >
              <template #default="scope">
                <div>
                  <el-form-item
                    :prop="'simulatorAnswers.' + scope.$index + '.description'"
                    :rules="[{ required: true, message: 'Respuesta requerida.'}, { validator: isAnswerValid}]"
                  >
                    <el-input
                      v-model="scope.row.description"
                      size="small"
                      placeholder="Texto de la alternativa..."
                      :class="'answer_editor_' + scope.$index"
                    />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="CORRECTA"
              width="130"
              align="center"
            >
              <template #default="scope">
                <div>
                  <el-switch
                    v-model="scope.row.success"
                    active-color="#10B981"
                    inactive-color="#CBD5E1"
                    active-text="SI"
                    inactive-text="NO"
                    size="small"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="OPCIONES"
              width="90"
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="danger"
                  size="small"
                  class="btn_delete_answer"
                  title="Eliminar respuesta"
                  @click="onDeleteAnswer(scope.$index)"
                >
                  <i class="fas fa-trash-alt" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>

    <!-- Pie del Modal Estandarizado -->
    <template #footer>
      <div class="student_modal_footer">
        <span class="footer_note">
          <i class="fas fa-shield-alt mr-1" />
          {{ isUpdate ? 'Los cambios se reflejarán de inmediato en los simuladores activos' : 'Configura las preguntas y alternativas antes de confirmar el registro' }}
        </span>
        <div class="footer_actions">
          <el-button
            v-if="formData.state === 'create' && active === 1"
            class="btn_prev_step"
            @click="onPrevStep"
          >
            <i class="fas fa-arrow-left mr-1" /> Anterior
          </el-button>
          <el-button
            class="btn_cancel_student_modal"
            @click="onCancel"
          >
            <i class="fas fa-times mr-1" /> Cancelar
          </el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            :loading="conf.isLoading"
            class="btn_submit_student_info"
            @click="onSubmitForm('formData')"
          >
            <i
              :class="submitIcon"
              class="mr-1"
            /> {{ submitLabel }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
